import { signInWithPopup,GoogleAuthProvider,onAuthStateChanged } from "firebase/auth";

const GoogleoAuth = (auth,redirect,setAuthenticated,setUserExists) => {

    const provider = new GoogleAuthProvider();
    // provider.addScope("https://www.googleapis.com/auth/contacts.readonly");

    signInWithPopup(auth, provider)
      .then((result) => {
        // This gives you a Google Access Token. You can use it to access the Google API.
        const credential = GoogleAuthProvider.credentialFromResult(result);
        const token = credential.accessToken;
        // The signed-in user info.
        const user = result.user;
        // IdP data available using getAdditionalUserInfo(result)
        // ...
        localStorage.setItem("isAuthenticated", "true");
        localStorage.setItem("userExists", "true");

        onAuthStateChanged(auth, (user) => {
          if (user) {
            setAuthenticated(true);
            setUserExists(true);
          } else {
            // User is signed out
            // ...
            setAuthenticated(false);
            setUserExists(false);
          }
        });

        redirect("/home");
      })
      .catch((error) => {
        // Handle Errors here.
        const errorCode = error.code;
        const errorMessage = error.message;
        // The email of the user's account used.
        const email = error.customData.email;
        // The AuthCredential type that was used.
        const credential = GoogleAuthProvider.credentialFromError(error);
        // ...
      });

}

export default GoogleoAuth;